// Product gallery thumbnails
function clearVideo() {
  var frame = document.querySelector('[data-gallery-main]');
  if (!frame) return;
  var v = frame.querySelector('[data-gallery-video]');
  if (v) v.remove();
  frame.classList.remove('has-video');
}
function showVideo(id, ratio) {
  var frame = document.querySelector('[data-gallery-main]');
  var tpl = document.querySelector('template[data-video-template="' + id + '"]');
  if (!frame || !tpl) return;
  clearVideo();
  var wrap = document.createElement('div');
  wrap.setAttribute('data-gallery-video', '');
  wrap.appendChild(tpl.content.cloneNode(true));
  frame.appendChild(wrap);
  frame.classList.add('has-video');
  if (ratio) frame.style.aspectRatio = ratio;
  var vid = wrap.querySelector('video');
  if (vid) { try { vid.play(); } catch (e) {} }
}
function setMainImage(src, ratio) {
  var frame = document.querySelector('[data-gallery-main]');
  var main = document.querySelector('[data-gallery-main] img');
  clearVideo();
  if (!main || !src) return;
  // Each photo keeps its own shape (square product shot, 4:5 styling shot)
  if (frame && ratio) frame.style.aspectRatio = ratio;
  main.removeAttribute('srcset');
  main.removeAttribute('sizes');
  main.src = src;
}
document.querySelectorAll('[data-thumb]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    if (btn.dataset.video) showVideo(btn.dataset.video, btn.dataset.ratio);
    else setMainImage(btn.dataset.src, btn.dataset.ratio);
    document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
  });
});

// Colour / option picker on product pages
(function () {
  var wrap = document.querySelector('[data-product-form-wrap]');
  if (!wrap) return;
  var dataEl = document.querySelector('script[data-variants]');
  if (!dataEl) return;
  var variants = JSON.parse(dataEl.textContent);
  var colorIndex = parseInt(wrap.dataset.colorIndex, 10);
  var prefix = wrap.dataset.prefix === 'true';
  var baseTitle = wrap.dataset.title;
  var idInput = wrap.querySelector('[data-variant-id]');
  var btns = wrap.querySelectorAll('[data-option-index]');
  var addBtn = wrap.querySelector('[data-add-btn]');
  var titleEl = wrap.querySelector('[data-product-title]');
  var priceEl = wrap.querySelector('[data-product-price]');
  if (!idInput) return;

  var selected = [];
  var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];
  selected = current.options.slice();

  function findVariant(changedIndex) {
    var exact = variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    })[0];
    if (exact) return exact;
    // fall back to the first variant that matches the option just changed
    return variants.filter(function (v) { return v.options[changedIndex] === selected[changedIndex]; })[0];
  }

  function markSoldOut() {
    btns.forEach(function (b) {
      var i = parseInt(b.dataset.optionIndex, 10);
      var any = variants.some(function (v) { return v.options[i] === b.dataset.value && v.available; });
      b.classList.toggle('is-soldout', !any);
    });
  }

  function render(changedIndex) {
    var v = findVariant(changedIndex);
    if (!v) return;
    current = v;
    selected = v.options.slice();
    idInput.value = v.id;
    btns.forEach(function (b) {
      var i = parseInt(b.dataset.optionIndex, 10);
      b.setAttribute('aria-pressed', selected[i] === b.dataset.value ? 'true' : 'false');
    });
    wrap.querySelectorAll('[data-selected-label]').forEach(function (el) {
      el.textContent = selected[parseInt(el.dataset.selectedLabel, 10)];
    });
    if (titleEl) {
      var colourName = colorIndex >= 0 ? selected[colorIndex] : '';
      var alreadyInTitle = colourName && baseTitle.toLowerCase().indexOf(colourName.toLowerCase()) !== -1;
      titleEl.textContent = (prefix && colourName && !alreadyInTitle) ? colourName + ' ' + baseTitle : baseTitle;
    }
    if (priceEl) {
      priceEl.innerHTML = (v.compare ? '<s>' + v.compare + '</s>' : '') + v.price;
    }
    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    }
    if (v.image) {
      setMainImage(v.image, v.ratio);
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
    }
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      var i = parseInt(b.dataset.optionIndex, 10);
      selected[i] = b.dataset.value;
      render(i);
    });
  });
  markSoldOut();
})();

// Rotating announcement bar (phones show one message at a time)
(function () {
  var bar = document.querySelector('[data-announcement]');
  if (!bar) return;
  var msgs = bar.querySelectorAll('.announcement-msg');
  if (msgs.length < 2) return;
  var ms = (parseInt(bar.dataset.interval, 10) || 5) * 1000;
  var i = 0, timer = null;
  function show(n) {
    msgs.forEach(function (m, k) { m.classList.toggle('is-active', k === n); });
    i = n;
  }
  function start() { stop(); timer = setInterval(function () { show((i + 1) % msgs.length); }, ms); }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  start();
  document.addEventListener('shopify:block:select', function (e) {
    msgs.forEach(function (m, k) { if (m === e.target || m.contains(e.target)) { show(k); stop(); } });
  });
  document.addEventListener('shopify:block:deselect', start);
})();

// Close the phone menu when tapping outside it or a link
(function () {
  var d = document.querySelector('[data-mobile-menu]');
  if (!d) return;
  document.addEventListener('click', function (e) { if (d.open && !d.contains(e.target)) d.open = false; });
  d.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { d.open = false; }); });
})();


// Header search drawer
(function () {
  var btn = document.querySelector('[data-search-toggle]');
  var box = document.querySelector('[data-search-drawer]');
  if (!btn || !box) return;
  var input = box.querySelector('input[type=search]');
  var menu = document.querySelector('[data-mobile-menu]');
  function setOpen(open) {
    box.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      if (menu) menu.removeAttribute('open');
      setTimeout(function () { input.focus(); }, 30);
    }
  }
  btn.addEventListener('click', function (e) { e.stopPropagation(); setOpen(!box.classList.contains('is-open')); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  document.addEventListener('click', function (e) {
    if (!box.contains(e.target) && !btn.contains(e.target)) setOpen(false);
  });
  if (menu) menu.addEventListener('toggle', function () { if (menu.open) setOpen(false); });
})();

// Page dropdowns: turns questions on a page into Care-instructions-style dropdowns.
// Headings listed in data-main (one per page section) stay on screen as main headings.
// Questions can be: a heading (h2-h6), a bold-only line, or a bold line followed by its answer in the same paragraph.
(function () {
  function norm(s) { return s.toLowerCase().replace(/&amp;|&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function level(el) {
    var m = /^H([1-6])$/.exec(el.tagName);
    if (m) return parseInt(m[1], 10);
    if (el.tagName === 'P' && el.children.length >= 1 && /^(STRONG|B)$/.test(el.children[0].tagName)) {
      var first = el.children[0];
      var rest = el.textContent.replace(first.textContent, '').trim();
      if (rest === '' && el.textContent.trim() !== '') return 7; // bold-only line
    }
    return 0;
  }
  // "<p><b>Question</b><br>Answer…</p>" -> {title, answer paragraph}
  function inlineQuestion(el) {
    if (el.tagName !== 'P') return null;
    var first = el.firstElementChild;
    if (!first || !/^(STRONG|B)$/.test(first.tagName)) return null;
    var n = el.firstChild;
    while (n && n !== first && n.nodeType === 3 && !n.textContent.trim()) n = n.nextSibling;
    if (n !== first) return null;
    var title = first.textContent.trim();
    if (!title) return null;
    var after = first.nextSibling;
    var hasMore = el.textContent.replace(first.textContent, '').trim() !== '';
    if (!hasMore) return null;
    var ans = el.cloneNode(true);
    var f = ans.firstElementChild;
    ans.removeChild(f);
    // drop line breaks directly after the question
    while (ans.firstChild && ((ans.firstChild.nodeType === 3 && !ans.firstChild.textContent.trim()) || ans.firstChild.tagName === 'BR')) ans.removeChild(ans.firstChild);
    return { title: title, answer: ans };
  }
  function makeDetails(title) {
    var det = document.createElement('details'); det.className = 'acc';
    var sum = document.createElement('summary'); sum.textContent = title;
    var body = document.createElement('div'); body.className = 'acc-body';
    det.appendChild(sum); det.appendChild(body);
    return { det: det, body: body };
  }
  function build(root) {
    if (root.getAttribute('data-acc-done')) return;
    root.setAttribute('data-acc-done', '1');
    var mains = (root.getAttribute('data-main') || '').split('|').map(norm).filter(Boolean);
    var kids = Array.prototype.slice.call(root.children);
    var wrap = null, cur = null;
    function addGroup(title) {
      if (!wrap) { wrap = document.createElement('div'); wrap.className = 'product-accordions'; root.insertBefore(wrap, cur_anchor); }
      var g = makeDetails(title); wrap.appendChild(g.det); cur = g.body; return g;
    }
    var cur_anchor = null;

    // Automatic mode (no main headings listed): biggest heading level stays as main heading, next level down become dropdowns
    var autoQ = null;
    if (!mains.length) {
      var levels = [];
      kids.forEach(function (k) { var l = level(k); if (l && levels.indexOf(l) < 0) levels.push(l); });
      levels.sort(function (a, b) { return a - b; });
      var pref = root.getAttribute('data-level') || 'auto';
      autoQ = pref === 'auto' ? (levels.length > 1 ? levels[1] : levels[0]) : (pref === 'bold' ? 7 : parseInt(pref, 10));
    }

    kids.forEach(function (k) {
      var l = level(k);
      var isMain = mains.length ? (l > 0 && mains.indexOf(norm(k.textContent)) > -1) : (l > 0 && l < autoQ);
      if (isMain) { k.classList.add('acc-main'); wrap = null; cur = null; return; }
      var isQ = mains.length ? l > 0 : (l > 0 && l === autoQ);
      if (isQ) {
        cur_anchor = k; addGroup(k.textContent.trim()); root.removeChild(k); return;
      }
      var iq = inlineQuestion(k);
      if (iq) {
        cur_anchor = k; addGroup(iq.title); if (iq.answer.textContent.trim() || iq.answer.children.length) cur.appendChild(iq.answer); root.removeChild(k); return;
      }
      if (cur) cur.appendChild(k);
    });
  }
  function init() { document.querySelectorAll('[data-rte-accordion]').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

// Slide-out cart: add-to-cart and the Cart button open a drawer on the right instead of loading the cart page.
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var cartUrl = drawer.getAttribute('data-cart-url') || '/cart';
  var lastFocus = null;

  function panel() { return drawer.querySelector('.cart-drawer-panel'); }
  function open() {
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    var p = panel(); if (p) p.focus();
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function showError(msg) {
    var el = drawer.querySelector('[data-cart-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }
  function updateHeaderCount(n) {
    document.querySelectorAll('.nav-cart').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart, ' + n + ' items');
      var c = a.querySelector('.cart-count');
      if (!c) return;
      var parens = c.querySelectorAll('.cart-paren');
      c.innerHTML = '<span class="cart-paren">(</span>' + n + '<span class="cart-paren">)</span>';
      if (!parens.length) c.textContent = n;
    });
  }
  function refresh() {
    return fetch(cartUrl + (cartUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-inner]');
        var cur = drawer.querySelector('[data-cart-inner]');
        var holder = doc.querySelector('[data-cart-drawer]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        if (holder) updateHeaderCount(holder.getAttribute('data-count'));
      });
  }

  // Add to cart (product page + quick-add buttons on product cards)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; if (btn.hasAttribute('data-add-btn')) btn.textContent = 'Adding…'; }
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        return refresh().then(function () {
          showError(res.ok ? '' : (res.body.description || res.body.message || 'Sorry, that item could not be added.'));
          open();
        });
      })
      .catch(function () { form.submit.call(form); })
      .then(function () {
        if (btn) { btn.disabled = false; if (btn.hasAttribute('data-add-btn')) btn.textContent = label; }
      });
  });

  // Header Cart button opens the drawer (except on the full cart page itself)
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.nav-cart') : null;
    if (a && !document.body.classList.contains('template-cart')) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      showError('');
      open();
      return;
    }
    if (e.target.closest && e.target.closest('[data-cart-close]')) { close(); return; }
    var ch = e.target.closest ? e.target.closest('[data-cart-change]') : null;
    if (ch && drawer.contains(ch)) {
      drawer.classList.add('is-loading');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ line: parseInt(ch.getAttribute('data-line'), 10), quantity: Math.max(0, parseInt(ch.getAttribute('data-qty'), 10)) }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) { return refresh().then(function () { showError(res.ok ? '' : (res.body.description || res.body.message || '')); }); })
        .catch(function () {})
        .then(function () { drawer.classList.remove('is-loading'); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
})();
